const Loadable = (Component) => (props) =>
  (
      <Component {...props} />
  );

export default Loadable